// extracted by mini-css-extract-plugin
module.exports = {"button":"CopyButton_button__rDJXc"};